const permission = (next, to) => {
  return next()
  // let permit = _.filter(to.meta.roles, function(role) {
  //   return role == store.state.auth.authUserRole[0].name
  // })
  // if (permit.length) {
  //   return next()
  // } else {
  //   return next({
  //     path: to.fullPath + '/404'
  //   })
  // }
}

export { permission }
